import { getAccessToken } from "../../services/authService";

// Keep server messages and support references, never raw HTML or stack traces.
export const readAdminResponse = async (res, path, method) => {
  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const serverMessage = [json?.message, json?.data?.message, json?.error].find(value => typeof value === 'string' && value.trim());
    const message = serverMessage || (res.status === 404 ? 'Requested service was not found. Check the AWS backend routes and deployment.' : 'The server could not complete this request.');
    const reference = json?.data?.errorId || json?.errorId;
    const error = new Error(`${message} (HTTP ${res.status}; ${method} ${path})${typeof reference === 'string' ? ` Reference: ${reference}` : ''}`);
    error.status = res.status;
    error.errorId = reference;
    error.details = json?.details || json?.data?.details;
    throw error;
  }
  return json;
};

// Shared request helper for the Admin area. The server enforces every permission.
export const adminRequest = async (path, { method = "GET", body } = {}) => {
  const token = getAccessToken();
  if (!token) throw new Error("Please sign in again.");
  // An empty place-library action is not an edit; older schedule servers reject this optional key.
  // Never retry a write or discard actual place changes to work around validation.
  const requestBody = body && path.includes('/schedule') && Array.isArray(body.placeActions) && body.placeActions.length === 0
    ? Object.fromEntries(Object.entries(body).filter(([key]) => key !== 'placeActions')) : body;
  const res = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, {
    method,
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(path.endsWith('/assistant/generate') && body?.useAi ? { 'X-AI-Request-Id': window.crypto.randomUUID() } : {}) },
    body: requestBody ? JSON.stringify(requestBody) : undefined,
  });
  const json = await readAdminResponse(res, path, method);
  return json.data || {};
};

// For endpoints that answer without the { data } wrapper (Script to Video test).
export const adminFetch = async (path, { method = "GET", body } = {}) => {
  const token = getAccessToken();
  if (!token) throw new Error("Please sign in again.");
  const res = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, { method, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` }, body: body ? JSON.stringify(body) : undefined });
  const json = await readAdminResponse(res, path, method);
  return json;
};

export const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : "—");
export const formatDateTime = (d) => (d ? new Date(d).toLocaleString() : "—");
